
import React,{useEffect,useState} from 'react'
import Axios from 'axios'
import Dialog from "@material-ui/core/Dialog";
import ResetOTP from './ResetOTP';
import ChangePassword from './ChangePassword';
// import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
    Card, Button, CardFooter, CardBody, FormGroup, Input, Container, Col, Form, FormFeedback, InputGroup, InputGroupAddon, InputGroupText
  } from 'reactstrap';
  
const ResetPasswordDialog = ({open,handleOpen,handleClose}) => {
    // const navigate = useNavigate();
    // const dispatch = useDispatch();
    const [otp,setOtp]= useState('');
    const [isOTPSuccess, setIsOTPSuccess] = useState(false);
   const handleOTPSuccess = (newOTP)=>{
    setOtp(newOTP); 
    setIsOTPSuccess(true)
   }
 
   
  return (
    <React.Fragment>
        <Dialog open  onClose={handleClose}  maxWidth="sm" >
        {isOTPSuccess ? 
        (<>
          <DialogTitle>Change Password</DialogTitle>
        <DialogContent>
          <ChangePassword otp={otp} email={null}/> 
          </DialogContent>
        </>)
       : 
       (<>
        <DialogTitle>Verify OTP</DialogTitle>
      <DialogContent>
        <ResetOTP handleOTPSuccess={handleOTPSuccess} />
        </DialogContent>
        </>)
        }
      
        </Dialog>
    </React.Fragment>
  )
}

export default ResetPasswordDialog